import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import Gbtn from "../../../Components/buttons/Gbtn";
import DashNav from "../../../Components/DashNav/DashNav";
import { FiEdit } from "react-icons/fi";
import { FcDocument } from "react-icons/fc";
import { GrDocumentMissing } from "react-icons/gr";
import { RiSignalWifiErrorLine, RiDeleteBin6Line } from "react-icons/ri";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../Components/LoadingSpinner/LoadingSpinner";
import noImage from "../../../Assests/avatar1.png";
import NewsPaper from "../../../Components/SVGS/NewsPaper";
import { HiOutlineDocumentMinus } from "react-icons/hi2";
import { getAllNE } from "../../../api";

function NewsEvent() {
  const icon = () => {
    return <NewsPaper size="26" height="30" fill="#DF2F35" />;
  };

  const location = useLocation();
  const CurrPage =
    location.state && location.state ? location.state.page : null;

  const navigate = useNavigate("");
  const addOnclick = () => {
    navigate("/dashboard/news&Events/add");
  };

  const [page, setPage] = useState(CurrPage !== null ? CurrPage : 1);
  const [limit, setLimit] = useState(10);
  const [totalRecords, setTotalRecords] = useState(10);
  const [NEData, setNEData] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [paginationDisplay, setPaginationDisplay] = useState("block");
  const [err, setErr] = useState(false);
  const [searchString, setSearchString] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    fetchData(page);
    // setNEData(arr);
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      if (searchString.trim() !== "") fetchData(page, searchString);
    }, 1500);
    return () => {
      clearTimeout(delay);
    };
  }, [searchString]);

  const fetchData = (pageNumber, searchTxt) => {
    setErr(false);
    setisLoading(true);
    getAllNE(limit, pageNumber, searchTxt)
      .then(({ data }) => {
        setisLoading(false);
        if (data.success) {
          setNEData(data.result);
          setTotalRecords(data.total_records);
          setPaginationDisplay("block");
          setPage(pageNumber);
        } else {
          if (data.error_code === 2) {
            setNEData(data.result);
            setErrorMsg(data.message);
          } else {
            setErr(true);
            setErrorMsg(data.message);
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
        setErr(true);
        setisLoading(false);
        setPaginationDisplay("none");
        setErrorMsg(err.message);
      });
  };

  const handlePageChange = (pageNumber) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (pageNumber >= 1) {
      setPage(pageNumber);
      fetchData(pageNumber, searchString);
    }
  };

  const handleSearch = (e) => {
    setSearchString(e.target.value);
    if (e.target.value === "") {
      fetchData(page);
    }
  };

  return (
    <>
      <div className="mainDashView">
        <div>
          <DashNav svg={icon} DashboardNavText="News & Events" />
        </div>

        <div className="dashPanel border-lt-Gray">
          <div className="r-ViewBar">
            <div className="r-ViewBar2">
              <div>
                <input
                  type="search"
                  value={searchString}
                  onChange={handleSearch}
                  placeholder="Search"
                  className="rolesSearch"
                />
              </div>
            </div>
            <div className="r-View-btn">
              <Gbtn
                text="Add"
                color="#DF2F35"
                radius="5px"
                width="200px"
                func={addOnclick}
              />
            </div>
          </div>
          {isLoading ? (
            <div>
              <LoadingSpinner />
            </div>
          ) : err ? (
            <div className="network-err-msg">Error! {errorMsg} </div>
          ) : NEData ? (
            <div className="tableContainer">
              <table className="roleViewTable" style={{ minWidth: "100%" }}>
                <thead>
                  <tr>
                    <th>Actions</th>
                    {/* <th>Upload Video</th> */}
                    <th>Upload PDF</th>
                    <th>Thumbnail</th>
                    <th>Title</th>
                    <th>Youtube Link</th>
                    <th>Detail Description</th>
                    <th>Short Description</th>
                    <th style={{ paddingRight: "20px" }}>Posted Date</th>
                  </tr>
                </thead>
                <tbody>
                  {NEData &&
                    NEData.map((data) => (
                      <Rows data={data} currentPage={page} />
                    ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="network-err-msg">{errorMsg}</div>
          )}
          <div className="paginationDiv" style={{ display: paginationDisplay }}>
            <Pagination
              activePage={page}
              itemsCountPerPage={limit}
              totalItemsCount={totalRecords}
              pageRangeDisplayed={3}
              onChange={(pageNumber) => {
                handlePageChange(pageNumber);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
const Rows = ({ data, currentPage }) => {
  const navigate = useNavigate();
  const editRole = () => {
    navigate("/dashboard/news&Events/edit", {
      state: { NEToEdit: data, page: currentPage },
    });
  };
  const delRole = () => {
    navigate("/dashboard/news&Events/delete", {
      state: { NEToEdit: data, page: currentPage },
    });
  };
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [imgErr, setImgErr] = useState(false);

  const handleImageErr = () => {
    setImgErr(true);
  };

  const getDate = (datee) => {
    const date = new Date(datee);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };
  return (
    <>
      {data && data ? (
        <tr>
          <td
            style={{
              minWidth: "60px",
            }}
          >
            <div style={{ display: "flex" }}>
              <button onClick={editRole} className="Actionbtn editBtn">
                <FiEdit />
              </button>
              <button onClick={delRole} className="Actionbtn delBtn">
                <RiDeleteBin6Line />
              </button>
            </div>
          </td>
          {/* <td>
            <img
              src={imgErr ? noImage : data.video_image}
              onError={handleImageErr}
              alt=""
              height={"28"}
              width={"28"}
              style={{
                borderRadius: "100%",
                border: "1px solid lightgray",
                borderBlockColor: "lightgray",
              }}
            />
          </td> */}
          <td>
            {data.document_path &&
              data.document_path !== "" &&
              data.document_path !== "null" ? (
              <FcDocument size={32} />
            ) : (
              <HiOutlineDocumentMinus size={26} color="#df2f35" />
            )}
          </td>
          <td>
            <img
              src={imgErr ? noImage : data.image_path ? (baseUrl + data.image_path) : (baseUrl + data.news_event_images[0]?.image_path)}
              onError={handleImageErr}
              alt=""
              height={"34"}
              width={"34"}
              style={{
                borderRadius: "100%",
                border: "1px solid lightgray",
                borderBlockColor: "lightgray",
              }}
            />
          </td>
          <td>{data.title}</td>
          <td className="break-line-170">{data.youtube_link}</td>
          <td
            className="break-line-270"
            style={{ padding: "0 30px" }}
            dangerouslySetInnerHTML={{
              __html:
                data.detailed_description &&
                  data.detailed_description.length > 200
                  ? data.detailed_description.substring(0, 200) + "..."
                  : data.detailed_description,
            }}
          ></td>
          <td className="break-line-200">
            {data.short_description && data.short_description.length > 140
              ? data.short_description.substring(0, 140) + "..."
              : data.short_description}
          </td>
          <td style={{ paddingRight: "20px" }}>{getDate(data.created_on)}</td>
        </tr>
      ) : null}
    </>
  );
};

export default NewsEvent;
